<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { recordingPausedNotification } from './notifications'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    created () {
      this.channel.bind('recording.paused', () => {
        this.markRecordingState('paused')
        this.markRecordingButtonDisabled(false)
        recordingPausedNotification().show()
      })
    },
    methods: mapActions([
      'markRecordingState',
      'markRecordingButtonDisabled'
    ])
  }
</script>



// WEBPACK FOOTER //
// recording-paused.vue?86ebbf10